<template>
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="closable"
        :modalBodyClass="modal.type ? 'm-modal-sucessfully m-modal-' + modal.type  : $prefixClass.modal + '-sucessfully' "
    >
       <i class="fad fa-check-circle m-b-16"></i>
       <h4 :class="[modal.description ? 'm-b-12' : 'm-b-0']">{{modal.title}}</h4>
       <template v-if="modal.description">
            <span  v-html="modal.description"></span>
            <br>
       </template>
       <a-button v-if="!hasSlotAction" :class="[modal.description ? 'm-t-16' : 'm-t-30']" type="primary" @click="onDone">{{btnText}}</a-button>
       <div :class="$prefixClass.modal + '-sucessfully-footer'">
            <slot name="action" />
        </div>
    </vue-modal>
</template>
<script>
export default {
    name: "ModalDataSynced",
    props: {
        value: {
            type: Object,
            required: true
        },
        closable: {
            type: Boolean,
            default: false
        },
        btnText: {
            type: String,
            default: 'Done'
        }
    },
    data() {
        return {

        }
    },
    computed: {
        modal: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        },
        hasSlotAction () { 
            return this.$slots.action 
        },
    },
    methods: {
        onDone() {
            this.modal.isVisible = false
        }
    }
}
</script>
<style lang="scss">
    .m-modal {
        &-sucessfully {
            text-align: center;
            .m-modal {
                &-body {
                    padding: 32px;
                }
            }
            .fa-check-circle {
                font-size: 48px;
                color: $success-color;
                opacity: 0.6;
            }
        }
        &-data-synced {
            .m-modal {
                &-body {
                    padding: 32px 64px;
                }
            }
        }
    }
</style>
